import { useMemo } from "react";
import useCommandFlowStore from "../../store/commandFlowStore";
import {
  getTerminalTextStyle,
  getInputStyle,
  getContainerStyle,
  getFormStyle,
  getPromptSpanStyle,
  getSuggestionStyle,
} from "../../utils/ui/terminalStyleUtils";

export const useTerminalStyles = (height, display, opacity, transition) => {
  const { isFocused, theme } = useCommandFlowStore();

  const styles = useMemo(() => {
    const terminalTextStyle = getTerminalTextStyle(theme);

    return {
      terminalTextStyle,
      inputStyle: getInputStyle(theme, isFocused, terminalTextStyle),
      containerStyle: getContainerStyle(
        theme,
        isFocused,
        terminalTextStyle,
        height,
        display,
        opacity,
        transition
      ),
      formStyle: getFormStyle(theme),
      promptSpanStyle: getPromptSpanStyle(theme, terminalTextStyle),
      currentPromptSpanStyle: getPromptSpanStyle(
        theme,
        terminalTextStyle,
        true
      ),
      suggestionStyle: getSuggestionStyle(terminalTextStyle),
    };
  }, [theme, isFocused, height, display, opacity, transition]);

  return styles;
};
